import { X } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
import Button from '../../ui/button';
import { dialogVariants, overlayVariants } from '../../../utils/framerMotion';
import { useDialog } from '../../../hooks/useDialog';

export default function ConfirmationDialog({
  isOpen = false,
  onClose = () => { },
  onConfirm = () => { },
  title = 'Confirm Action',
  message = 'Are you sure you want to proceed?',
  confirmText = 'Confirm',
  cancelText = 'Cancel',
}) {
  const dialogRef = useDialog<HTMLDivElement>({ isOpen, onClose });

  return (
    <AnimatePresence>
      {isOpen && (
        <>
          <motion.div
            className="fixed inset-0 bg-black/50 backdrop-blur-sm z-50"
            variants={overlayVariants}
            initial="hidden"
            animate="visible"
            exit="exit"
            onClick={onClose}
          />

          <div className="fixed inset-0 flex items-center justify-center z-50 px-4">
            <motion.div
              ref={dialogRef}
              role="dialog"
              aria-modal="true"
              aria-labelledby="confirmation-dialog-title"
              tabIndex={-1}
              variants={dialogVariants}
              initial="hidden"
              animate="visible"
              exit="exit"
              className="bg-[#141009] border border-[#BBA473]/25 rounded-xl p-6 w-full max-w-md relative"
            >
              <Button variant='noneBorder' onClick={onClose} aria-label="Close">
                <X size={20} />
              </Button>
              <h2 id="confirmation-dialog-title" className="text-xl font-semibold text-[#BBA473] mb-3">
                {title}
              </h2>

              <p className="text-[#d8d2c4] mb-6">
                {message}
              </p>

              <div className="flex justify-end gap-3">
                <Button
                  onClick={onClose}
                  className='px-4 py-2 rounded-md bg-[#1e1a10] text-[#E8D5A3] border border-[#BBA473]/25 hover:bg-[#241d10] transition-colors duration-200'>
                  {cancelText}
                </Button>
                <Button
                  onClick={() => {
                    onConfirm();
                    onClose();
                  }}
                  variant='gold'
                >
                  {confirmText}
                </Button>
              </div>
            </motion.div>
          </div>
        </>
      )}
    </AnimatePresence>
  );
}